import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AddQuestionGuard  {
  constructor(private router: Router) {}

  canActivate(): boolean | UrlTree {
    const questionData = localStorage.getItem('questionData');
    return !!questionData || this.router.parseUrl('/questions');
  }
}
